import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css";
import { navigateModule } from "../services/navigateService";
import { logOut, changepassword, getLoginHistory } from "../api/loginApiService";
import appConfig from "../config/appConfig";
import UserInfo from "../Components/UserInfo";
import ChangePassword from "../Components/ChangePassword";
import { CustomSwal } from "../services/customSwal";
import aesEncryptionService from "../services/aesEncryptionService";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Types
type SubModule = {
  ModuleId: string;
  ModuleName: string;
  image: string;
  description: string;
  websiteId: string;
  websiteUrl: string;
};

type MainModule = {
  ModuleGroupId: string;
  ModuleGroupName: string;
  image: string;
  description: string;
  subModules: SubModule[];
};

const Dashboard: React.FC = () => {
  const [activeMain, setActiveMain] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);
  const [staffId, setStaffId] = useState<string | null>(null);
  const [DOB, setDOB] = useState<string | null>(null);
  const [mobile, setmobile] = useState<string | null>(null);
  const [email, setemail] = useState<string | null>(null);
  const [company, setcompany] = useState<string | null>(null);
  const [EVerify, setEVerify] = useState<string | null>(null);
  const [MVerify, setMVerify] = useState<string | null>(null);
  const [department, setdepartment] = useState<string | null>(null);
  const [designation, setdesignation] = useState<string | null>(null);
  const [showSettings, setShowSettings] = useState(false);
  const [showChangePwd, setShowChangePwd] = useState(false);
  const [showLoginHistory, setShowLoginHistory] = useState(false);
  const [loginHistory, setLoginHistory] = useState<any[]>([]);
  const [pwdMessage, setPwdMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | null>(null);
  const [showAllRecords, setShowAllRecords] = useState(false);
  const [filteredModules, setFilteredModules] = useState<MainModule[]>([]);
  const [inProgressModule, setInProgressModule] = useState<SubModule | null>(null);
  const [pageSize, setPageSize] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [exportText, setExportText] = useState("Export");
  const [showExportMenu, setShowExportMenu] = useState(false);

  const navigate = useNavigate();


  const initializeUserFromPost = (): boolean => {
    let encryptedData: string | null = null;
    //let encryptedData = sessionStorage.getItem("UserDetails");
    //sessionStorage.setItem("UserDetails", encryptedData);
    // Try to read POSTed form data (only available on first load)
    /*    if (document.forms.length > 0) {
         const formData = new FormData(document.forms[0]);
         const postedData = formData.get("data");
         if (postedData) {
           encryptedData = postedData.toString();
           sessionStorage.setItem("UserDetails", encryptedData);
         }
       } */

    // Fallback to sessionStorage (refresh / internal navigation)
    // if (!encryptedData) {
    //   encryptedData = sessionStorage.getItem("UserDetails");
    // }

    if (!sessionStorage.getItem("UserDetails")) {
      encryptedData = sessionStorage.getItem("UserDetails");
    }
    console.log('userdetails - ', sessionStorage.getItem("UserDetails"));

    if (!encryptedData) return false;

    // Decrypt
    const decryptedResponse = aesEncryptionService.decryptData(encryptedData);
    if (!decryptedResponse || !decryptedResponse.Result) return false;

    // Store user info
    sessionStorage.setItem("UserName", decryptedResponse.UserName);
    sessionStorage.setItem("staff_id", decryptedResponse.User);
    sessionStorage.setItem("Mobile", decryptedResponse.Mobile);
    sessionStorage.setItem("EmailId", decryptedResponse.EmailId);
    sessionStorage.setItem("CompName", decryptedResponse.CompName);
    sessionStorage.setItem("DOB", decryptedResponse.DOB);
    sessionStorage.setItem("Department", decryptedResponse.Department);
    sessionStorage.setItem("Designation", decryptedResponse.Designation);
    sessionStorage.setItem("EVerify", decryptedResponse.EVerify);
    sessionStorage.setItem("MVerify", decryptedResponse.MVerify);
    sessionStorage.setItem(
      "CardUIData",
      JSON.stringify(decryptedResponse.CardUIData || [])
    );

    return true;
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem("UserName");
    const storedModules = JSON.parse(sessionStorage.getItem("CardUIData") || "[]");

    if (!storedUser) {
      const success = initializeUserFromPost();
      if (!success) {

        navigate("/");
        return;
      }
    }



    const filtered: MainModule[] = storedModules.reduce((acc: MainModule[], sm: any) => {
      let group = acc.find((g) => g.ModuleGroupId === sm.Card_Group_id);
      if (!group) {
        group = {
          ModuleGroupId: sm.Card_Group_id,
          ModuleGroupName: sm.Card_Group_name,
          image: sm.group_image_path || "/assets/default.png",
          description: sm.group_description || "",
          subModules: [],
        };
        acc.push(group);
      }

      group.subModules.push({
        ModuleId: sm.Card_id,
        ModuleName: sm.Card_name,
        image: sm.card_image_path,
        description: sm.card_description || "",
        websiteId: sm.card_website_id,
        websiteUrl: sm.card_website_Url || "",
      });

      return acc;
    }, []);

    setFilteredModules(filtered);

    const allGroupsHaveSingleSubModule = filtered.every((group) => group.subModules.length === 1);

    if (!allGroupsHaveSingleSubModule && filtered.length >= 1) {
      setActiveMain(filtered[0].ModuleGroupId);
    }

    // if (filtered.length === 1 && filtered[0].subModules.length === 1) {
    //   const onlySub = filtered[0].subModules[0];
    //   navigateModule(onlySub.ModuleName, onlySub.websiteId, onlySub.websiteUrl, navigate);
    //   return;
    // }

    // Set user info
    setUsername(storedUser);
    setStaffId(sessionStorage.getItem("staff_id"));
    const rawDOB = sessionStorage.getItem("DOB");
    setDOB(rawDOB ? rawDOB.split(" ")[0] : null);
    setmobile(sessionStorage.getItem("Mobile"));
    setemail(sessionStorage.getItem("EmailId"));
    setdepartment(sessionStorage.getItem("Department"));
    setdesignation(sessionStorage.getItem("Designation"));
    setcompany(sessionStorage.getItem("CompName"));
    setEVerify(sessionStorage.getItem("EVerify"));
    setMVerify(sessionStorage.getItem("MVerify"));
  }, [navigate]);

  const allGroupsHaveSingleSubModule = filteredModules.every((group) => group.subModules.length === 1);
  const showMainModules = !allGroupsHaveSingleSubModule && filteredModules.length > 1;

  const logout = async () => {
    try {
      if (staffId) await logOut(staffId);
    } finally {
      sessionStorage.clear();
      navigate("/");
      //window.location.href = appConfig.LoginUI;
    }
  };

  const handlePasswordUpdate = async (oldPwd: string, newPwd: string, confirmPwd: string) => {
    if (!oldPwd || !newPwd || !confirmPwd) {
      setPwdMessage("All fields are required.");
      return;
    }
    if (newPwd !== confirmPwd) {
      setPwdMessage("New password and Confirm password do not match.");
      return;
    }

    try {
      const staff_id = sessionStorage.getItem("staff_id") || "";
      const apiResponse = await changepassword(staff_id, oldPwd, newPwd, confirmPwd);

      if (apiResponse.status === "1") {
        CustomSwal.fire("Updated", "Password updated successfully. Please login again.", "success");
        sessionStorage.clear();
        navigate("/");
      } else {
        setPwdMessage(apiResponse.message || "Failed to update password.");
      }
    } catch (err) {
      console.error("Error:", err);
      setPwdMessage("Something went wrong. Please try again.");
    }
  };

  const formatDateTime = (dateTimeStr: string) => {
    if (!dateTimeStr) return "";

    const [datePart, timePart] = dateTimeStr.split(" ");
    if (!datePart || !timePart) return dateTimeStr;

    const [day, month, year] = datePart.split("/").map(Number);
    const [hours24, minutes, seconds] = timePart.split(":").map(Number);

    const ampm = hours24 >= 12 ? "PM" : "AM";
    let hours12 = hours24 % 12;
    hours12 = hours12 === 0 ? 12 : hours12;

    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}-${hours12.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${ampm}`;
  };

  const fetchLoginHistory = async () => {
    try {
      const staff_id = sessionStorage.getItem("staff_id") || "";
      const inst_id = sessionStorage.getItem("Inst_id") || "";

      const response = await getLoginHistory(staff_id, inst_id);

      if (response.status === "1" && response.data) {
        const formattedData = response.data.map((item: any) => {
          const loginDateTime = formatDateTime(item.login_time);
          const logoutDateTime = item.logout_time ? formatDateTime(item.logout_time) : "-";

          return {
            staffId: item.staff_id,
            dateTime: loginDateTime,  // <-- full Date-Time
            logoutDateTime: logoutDateTime,
            machineIp: item.machine_ip || "-",
          };
        });

        setLoginHistory(formattedData);
      } else {
        setLoginHistory([]);
      }
    } catch (err) {
      console.error("Failed to fetch login history", err);
      setLoginHistory([]);
    }
  };

  const filteredSortedData = loginHistory
    .filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    .sort((a, b) => {
      if (!sortConfig) return 0;
      const aVal = a[sortConfig.key] || "";
      const bVal = b[sortConfig.key] || "";
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });

  const requestSort = (key: string) => {
    let direction: "asc" | "desc" = "asc";
    if (sortConfig?.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Export to Excel (matching PDF columns)
  const exportToExcel = () => {
    const tableColumn = ["Staff ID", "Login", "Logout", "Machine IP"];

    // Map data to match the column order
    const tableRows = filteredSortedData.map((item) => ({
      "Staff ID": item.staffId,
      "Login": item.dateTime,
      "Logout": item.logoutDateTime,
      "Machine IP": item.machineIp,
    }));

    // Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(tableRows, { header: tableColumn });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "LoginHistory");

    // Auto-adjust column widths
    ws["!cols"] = tableColumn.map(() => ({ wch: 20 }));

    XLSX.writeFile(wb, "LoginHistory.xlsx");
  };

  // Export to PDF (same columns)
  const exportToPDF = () => {
    const doc = new jsPDF();
    const tableColumn = ["Staff ID", "Login", "Logout", "Machine IP"];
    const tableRows = filteredSortedData.map((item) => [
      item.staffId,
      item.dateTime,
      item.logoutDateTime,
      item.machineIp,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save("LoginHistory.pdf");
  };
  const paginatedData = filteredSortedData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalPages = Math.ceil(filteredSortedData.length / pageSize);

  const goToPage = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="dashboardcontainer">
      <video autoPlay muted loop className="bgvideo" onLoadedMetadata={(e) => e.currentTarget.playbackRate = 0.6}>
        <source src="/assets/BgVideo.mp4" type="video/mp4" />
      </video>

      <nav className="navbar">
        <div className="navbarleft">
          <a href="/dashboard">
            <img src="/assets/psg.png" alt="HRM" className="navbarlogo" />
          </a>
        </div>
        <div className="navbarright">
          <span className="username">{username}</span>
          <i className="fas fa-cog settingsicon" onClick={() => {
            if (showSettings) {
              setShowChangePwd(false);
              setShowLoginHistory(false);
            }
            setShowSettings(!showSettings);
          }}></i>
          <i className="fas fa-sign-out-alt logouticon" onClick={logout}></i>
        </div>
      </nav>
      <div className={`maincontent splitlayout ${showMainModules ? "multiplemain" : "singlemain"} ${showSettings ? "settingsvisible" : ""}`}>

        {/* <div className={`maincontent splitlayout ${showSettings ? "settingsvisible" : ""}`}> */}
        {!allGroupsHaveSingleSubModule && filteredModules.length > 1 && (
          <div className="mainmoduleselector">
            {filteredModules.map((main) => (
              <div
                key={main.ModuleGroupId}
                className={`mainmodulecard ${activeMain === main.ModuleGroupId ? "active" : ""}`}
                onClick={() => {
                  if (main.subModules.length === 1) {
                    const onlySub = main.subModules[0];
                    navigateModule(onlySub.ModuleName, onlySub.websiteId, onlySub.websiteUrl, navigate);
                    //navigateModule(onlySub.ModuleName, onlySub.websiteId, "http://localhost:18448/GenWfLogin.aspx", navigate);
                  } else {
                    // Show submodules carousel
                    setActiveMain(null);
                    setTimeout(() => setActiveMain(main.ModuleGroupId), 50);
                  }
                }}
              >
                <img src={`/assets/${encodeURI(main.ModuleGroupName)}.png`} alt={main.ModuleGroupName} className={`mainmoduleimage ${activeMain ? "shrink" : ""}`} />
                <h1 className="mainmoduletitle">{main.ModuleGroupName}</h1>
                {activeMain === main.ModuleGroupId && main.description && <p className="mainmoduledesc">{main.description}</p>}
              </div>
            ))}
          </div>
        )}

        {(activeMain || allGroupsHaveSingleSubModule) && (
          <div className="submoduleslayout">
            {inProgressModule ? (
              <div className="submodulecarousel">
                <div className="nomodules">
                  <h2 className="nomodulesHead">In Progress</h2>
                  <h6 className="nomodulesMsg">
                    The {inProgressModule.ModuleName} module is under process
                  </h6>
                  <button
                    className="btn btn-secondary mt-3"
                    onClick={() => setInProgressModule(null)}
                  >
                    Go Back
                  </button>
                </div>
              </div>
            ) : filteredModules.length === 0 ? (
              <div className="submodulecarousel">
                <div className="nomodules">
                  <h2 className="nomodulesHead">No modules available.</h2>
                  <h6 className="nomodulesMsg">Please contact administration.</h6>
                </div>
              </div>
            ) : (
              <div className="submodulecarousel">
                {!allGroupsHaveSingleSubModule && activeMain && (
                  <div className="subModuleCardHeader">
                  {
                    filteredModules.find(
                      (m) => m.ModuleGroupId === activeMain
                         )?.ModuleGroupName || ""
                         }
             </div>
                )}
                {(allGroupsHaveSingleSubModule
                  ? filteredModules.flatMap((m) => m.subModules)
                  : filteredModules.find((m) => m.ModuleGroupId === activeMain)?.subModules || []
                ).map((sub) => (
                  <div
                    key={sub.ModuleId}
                    className="submoduleitem"
                    onClick={() => {
                      if (!sub.websiteUrl) {
                        setInProgressModule(sub);
                      } else {
                        navigateModule(sub.ModuleName, sub.websiteId, sub.websiteUrl, navigate);
                        //navigateModule(sub.ModuleName, sub.websiteId, "http://localhost:18448/GenWfLogin.aspx", navigate);
                      }
                    }}
                  >
                    <img src={`${sub.image}`} alt={sub.ModuleName} className="SubModuleImg" />
                    <h6 className="subModuleName">{sub.ModuleName}</h6>
                  </div>
                ))}
              </div>
            )}
          </div>

        )}
      </div>

      {showSettings && (
        <div className="settingspanel">
          <i
            className="fas fa-times closesettingsicon"
            onClick={() => {
              setShowSettings(false);
              setShowChangePwd(false);
              setShowLoginHistory(false);
              setShowExportMenu(false);
            }}
          ></i>
          {!showChangePwd && !showLoginHistory ? (
            <UserInfo
              username={username}
              staffId={staffId}
              dob={DOB}
              mobile={mobile}
              email={email}
              department={department}
              designation={designation}
              company={company}
              Everify={EVerify}
              Mverify={MVerify}
              onChangePassword={() => setShowChangePwd(true)}
              onViewLoginHistory={() => {
                fetchLoginHistory();
                setShowLoginHistory(true);
              }}
            />
          ) : showChangePwd ? (
            <ChangePassword
              onBack={() => setShowChangePwd(false)}
              onPasswordUpdate={handlePasswordUpdate}
              pwdMessage={pwdMessage}
              onClose={() => setShowSettings(false)}
            />
          ) : (
            <div className="loginhistorypanel">
              {/* <button className="btn btnsecondary" onClick={() => {
                setShowLoginHistory(false);
                setShowAllRecords(false);
              }}>
                Back
              </button> */}
              <div className="panelheader">
                <i className="fas fa-arrow-left backicon" onClick={() => {
                  setShowLoginHistory(false);
                  setShowAllRecords(false);
                  setShowExportMenu(false);
                }}></i>
                <h4 className="paneltitle text-center">Login History</h4>
              </div>
              <div className="LoginHisHead">
                <div className="exportdropdown">
                  <div className="exportbuttoncontainer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowExportMenu(!showExportMenu)}
                    >
                      {exportText}
                    </button>

                    {showExportMenu && (
                      <div className="exportmenu">
                        <a
                          href="#!"
                          onClick={() => {
                            exportToPDF();
                            setExportText("Export");
                            setShowExportMenu(false);
                          }}
                        >
                          PDF
                        </a>
                        <a
                          href="#!"
                          onClick={() => {
                            exportToExcel();
                            setExportText("Export");
                            setShowExportMenu(false);
                          }}
                        >
                          Excel
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className="pagesizedropdown">
                  <label>Page Size: </label>
                  <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <input
                  type="text"
                  placeholder="Search all fields..."
                  className="searchinput"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {loginHistory.length === 0 ? (
                <p>No login history found.</p>
              ) : (
                <div className="tablewrapper">
                  <table className="logintable">
                    <thead>
                      <tr>
                        <th onClick={() => requestSort("staffId")}>Staff ID ⬍</th>
                        <th onClick={() => requestSort("loginTime")}>Login ⬍</th>
                        <th onClick={() => requestSort("logoutTime")}>Logout ⬍</th>
                        <th onClick={() => requestSort("machineIp")}>Machine IP ⬍</th>
                      </tr>
                    </thead>
                    <tbody className={showAllRecords ? "scrollabletbody" : ""}>
                      {filteredSortedData
                        .slice(0, showAllRecords ? filteredSortedData.length : pageSize)
                        .map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.staffId}</td>
                            <td>{item.dateTime}</td>   {/* <-- show full Date-Time */}
                            <td>{item.logoutDateTime}</td>
                            <td>{item.machineIp}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {/* Footer fixed at bottom of container */}
                  <div className="tablefooter">
                    <div className="recordsinfo">
                      {filteredSortedData.length > 0 ?
                        `Showing ${(currentPage - 1) * pageSize + 1} to ${Math.min(currentPage * pageSize, filteredSortedData.length)} of ${filteredSortedData.length} records`
                        : "No records found"}
                    </div>
                    <div className="paginationcontrols">
                      <button onClick={() => goToPage(1)} disabled={currentPage === 1}>⏮</button>
                      <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>◀</button>
                      <span>{currentPage} / {totalPages}</span>
                      <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>▶</button>
                      <button onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}>⏭</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
